/*
|--------------------------------------------------------------------------
| CONTENTFUL ENTRY IDS
|--------------------------------------------------------------------------
*/

/** Contentful entry ID for navigation/sidebar labels */
export const NAVIGATION_LABELS_ID = '3VELfyNnsE7EVI4sEb47rx';

/** Contentful entry ID for Accept Invitation page labels */
export const ACCEPT_INVITATION_LABELS_ID = '6WHXMhiJlf64IjngoIFQvJ';

/** Contentful entry ID for Admin / Workspace Access labels */
export const WORKSPACE_ACCESS_LABELS_ID = '6BqVZ9X8vHKjR2YwQnMtPL';

/** Contentful entry ID for Prospect Desk / Create New Prospect labels */
export const CREATE_NEW_PROSPECT_LABELS_ID = '4bKjJdtPivFmf27zAfOSK5';

/** Contentful entry ID for Prospect Desk / Prospects labels */
export const PROSPECTS_LABELS_ID = '6dhtpdHCYn1jTZ1cRAXtJR';

/** Contentful entry ID for Manage Orders labels */
export const MANAGE_ORDERS_LABELS_ID = '4Gjtd2V6GQE26D0pFnzh1i';

/**
 * Default locale when no user preference is persisted.
 * German market is the primary launch market.
 */
export const DEFAULT_LOCALE = 'de-de';

/** Default language override — English labels for non-English locales */
export const DEFAULT_LANGUAGE = 'en';
